/* eslint-disable */
// automatically generated by the FlatBuffers compiler, do not modify

import * as flatbuffers from 'flatbuffers';

import { FSFBDetectedFrameworks } from './fsfbdetected-frameworks';
import { FSFBStableSelectors } from './fsfbstable-selectors';

export class IOSBundleProto {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): IOSBundleProto {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsIOSBundleProto(bb: flatbuffers.ByteBuffer, obj?: IOSBundleProto): IOSBundleProto {
    return (obj || new IOSBundleProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  static getSizePrefixedRootAsIOSBundleProto(
    bb: flatbuffers.ByteBuffer,
    obj?: IOSBundleProto,
  ): IOSBundleProto {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new IOSBundleProto()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
  }

  cfbundleDisplayName(): string | null;
  cfbundleDisplayName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cfbundleDisplayName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cfbundleName(): string | null;
  cfbundleName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cfbundleName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cfbundleShortVersionString(): string | null;
  cfbundleShortVersionString(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cfbundleShortVersionString(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cfbundleVersion(): string | null;
  cfbundleVersion(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cfbundleVersion(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  cfbundleIdentifier(): string | null;
  cfbundleIdentifier(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  cfbundleIdentifier(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  detectedFrameworks(index: number): FSFBDetectedFrameworks | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : 0;
  }

  detectedFrameworksLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  detectedFrameworksArray(): Int8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return offset
      ? new Int8Array(
          this.bb!.bytes().buffer,
          this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
          this.bb!.__vector_len(this.bb_pos + offset),
        )
      : null;
  }

  stableSelectorsSwiftUi(): FSFBStableSelectors {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : FSFBStableSelectors.NOT_AVAILABLE;
  }

  swiftUiselectorVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : -1;
  }

  static startIOSBundleProto(builder: flatbuffers.Builder) {
    builder.startObject(8);
  }

  static addCfbundleDisplayName(
    builder: flatbuffers.Builder,
    cfbundleDisplayNameOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(0, cfbundleDisplayNameOffset, 0);
  }

  static addCfbundleName(builder: flatbuffers.Builder, cfbundleNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, cfbundleNameOffset, 0);
  }

  static addCfbundleShortVersionString(
    builder: flatbuffers.Builder,
    cfbundleShortVersionStringOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(2, cfbundleShortVersionStringOffset, 0);
  }

  static addCfbundleVersion(
    builder: flatbuffers.Builder,
    cfbundleVersionOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(3, cfbundleVersionOffset, 0);
  }

  static addCfbundleIdentifier(
    builder: flatbuffers.Builder,
    cfbundleIdentifierOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(4, cfbundleIdentifierOffset, 0);
  }

  static addDetectedFrameworks(
    builder: flatbuffers.Builder,
    detectedFrameworksOffset: flatbuffers.Offset,
  ) {
    builder.addFieldOffset(5, detectedFrameworksOffset, 0);
  }

  static createDetectedFrameworksVector(
    builder: flatbuffers.Builder,
    data: FSFBDetectedFrameworks[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(data[i]!);
    }
    return builder.endVector();
  }

  static startDetectedFrameworksVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addStableSelectorsSwiftUi(
    builder: flatbuffers.Builder,
    stableSelectorsSwiftUi: FSFBStableSelectors,
  ) {
    builder.addFieldInt8(6, stableSelectorsSwiftUi, FSFBStableSelectors.NOT_AVAILABLE);
  }

  static addSwiftUiselectorVersion(builder: flatbuffers.Builder, swiftUiselectorVersion: number) {
    builder.addFieldInt32(7, swiftUiselectorVersion, -1);
  }

  static endIOSBundleProto(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    return offset;
  }

  static createIOSBundleProto(
    builder: flatbuffers.Builder,
    cfbundleDisplayNameOffset: flatbuffers.Offset,
    cfbundleNameOffset: flatbuffers.Offset,
    cfbundleShortVersionStringOffset: flatbuffers.Offset,
    cfbundleVersionOffset: flatbuffers.Offset,
    cfbundleIdentifierOffset: flatbuffers.Offset,
    detectedFrameworksOffset: flatbuffers.Offset,
    stableSelectorsSwiftUi: FSFBStableSelectors,
    swiftUiselectorVersion: number,
  ): flatbuffers.Offset {
    IOSBundleProto.startIOSBundleProto(builder);
    IOSBundleProto.addCfbundleDisplayName(builder, cfbundleDisplayNameOffset);
    IOSBundleProto.addCfbundleName(builder, cfbundleNameOffset);
    IOSBundleProto.addCfbundleShortVersionString(builder, cfbundleShortVersionStringOffset);
    IOSBundleProto.addCfbundleVersion(builder, cfbundleVersionOffset);
    IOSBundleProto.addCfbundleIdentifier(builder, cfbundleIdentifierOffset);
    IOSBundleProto.addDetectedFrameworks(builder, detectedFrameworksOffset);
    IOSBundleProto.addStableSelectorsSwiftUi(builder, stableSelectorsSwiftUi);
    IOSBundleProto.addSwiftUiselectorVersion(builder, swiftUiselectorVersion);
    return IOSBundleProto.endIOSBundleProto(builder);
  }
}
